import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { isProductionHost } from 'lib/env';

interface IRouteDebuggerProps {
    children: JSX.Element;
    enabled: boolean;
}

const RouteDebugger = ({ children, enabled }: IRouteDebuggerProps) => {
    const history = useHistory();
    useEffect(() => {
        if (!enabled || isProductionHost()) return;

        console.log('initial history is: ', JSON.stringify(history, null, 2));
        history.listen((location, action) => {
            console.log(
                `The current URL is ${location.pathname}${location.search}${location.hash}`
            );
            console.log(`The last navigation action was ${action}`, JSON.stringify(history, null, 2));
        });
// eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return children;
};

export default RouteDebugger;
